import { useTrans } from "../../../hooks";
import { useAuthData } from "../../../contexts";
import {
    AppLoader,
    AppPageHeader,
    AppStatasticCard,
    AppStatasticListCard,
} from "../../../components";
import { AppLineChart } from "../../../components/AppLineChart";
import { Box, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { DashboardApi } from "../../../apis";
import { useNavigate } from "react-router-dom";
import { APPC, cPath } from "../../../config";
import { DashboardTransactionStatResponse } from "../../../apis/entities/dtos";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export const DashboardPage = () => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    // hooks
    const { t } = useTrans();
    const navigate = useNavigate();
    const toast = useToast();
    const { user } = useAuthData();

    // state & const
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<DashboardTransactionStatResponse>();

    useEffect(() => {
        setLoading(true);
        DashboardApi.dashboardTransactionStat<DashboardTransactionStatResponse>()
            .then(({ errorMessage, response }) => {
                if (errorMessage) {
                    toast({
                        title: errorMessage,
                        status: "error",
                    });
                } else if (response !== null) {
                    const sbd = response.statByDate?.map((item) => {
                        item.amount = Number(item.amount) / 100;
                        item.day = dayjs(item.day)
                            .tz(APPC.TIMEZONE)
                            .format("DD/MM");
                        return item;
                    });
                    setData({ ...response, statByDate: sbd });
                }
            })
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <AppLoader />;
    }
    return (
        <>
            <AppPageHeader
                title={t("padm.DashboardPage:text.dashboard")}
            ></AppPageHeader>
            <div
                style={{
                    display: "flex",
                    padding: "24px 24px 0px 24px",
                    gap: "24px",
                    boxSizing: "border-box",
                    flexWrap: "wrap",
                }}
            >
                {data &&
                    Object.keys(data?.stat)?.map((item) => (
                        <Box
                            key={item}
                            w={"full"}
                            maxW={{
                                md: "100%",
                                lg: "calc(50% - 12px)",
                                xl: "calc(25% - 18px)",
                            }}
                        >
                            <AppStatasticCard
                                text1={t(`padm.DashboardPage:text.${item}`)}
                                text2={t("padm.DashboardPage:text.amount")}
                                text3={`\u20AC ${Number(data?.stat?.[item].amount) / 100}`}
                                text4={t("padm.DashboardPage:text.transaction")}
                                text5={data?.stat?.[item].count}
                                iconName="icl-donate"
                            />
                        </Box>
                    ))}
            </div>
            <div
                style={{
                    display: "flex",
                    padding: "24px 24px 0px 24px",
                    gap: "24px",
                    boxSizing: "border-box",
                    flexWrap: "wrap",
                }}
            >
                <Box
                    w={"full"}
                    maxW={{
                        md: "100%",
                        lg: "calc(50% - 12px)",
                        xl: "calc(25% - 18px)",
                    }}
                >
                    <AppStatasticListCard
                        title={t("padm.DashboardPage:text.recentTransaction")}
                        data={data?.recentTransactions || []}
                        onClick={() =>
                            navigate(
                                user?.roles[0] === APPC.BE.User.ROLE_SUPER_ADMIN
                                    ? cPath("ADMIN.DONATION_TRANSACTION_PAGE")
                                    : cPath(
                                          "ADMIN.MY_DONATION_TRANSACTION_PAGE"
                                      )
                            )
                        }
                    />
                </Box>
                <Box
                    w={"full"}
                    height={525}
                    maxW={{
                        md: "100%",
                        lg: "calc(50% - 12px)",
                        xl: "calc(75% - 6px)",
                    }}
                    border={"1px solid var(--chakra-colors-greyT90)"}
                    borderRadius={"4px"}
                    bg={"var(--chakra-colors-white)"}
                    p={8}
                >
                    <AppLineChart data={data?.statByDate || []} />
                </Box>
            </div>
        </>
    );
};
